exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".avatar-ca231{margin-right:10px}.jiraName-60715{font-weight:600}", ""]);

// Exports
exports.locals = {
	"avatar": "avatar-ca231",
	"jiraName": "jiraName-60715"
};